module.exports = __webpack_public_path__ + "static/use-the-figma-library-936f16fb4bd48cbb7a49e69a4453cc8e.png";